'use client'
import { useGetFlightOffersQuery } from '@/src/api/rtkQuery/offersApi'
import { domainCountry } from '@/src/constants/domain'
import { FlightOffer } from '@/src/types/flightOffer'
import { Offer } from '@/src/types/offers'
import { useMemo } from 'react'
import { OffersGrid } from './offersGrid'

const OffersGridWrapper: React.FC = () => {
    const { data: offersData, isLoading, isError, error } = useGetFlightOffersQuery({ domain: domainCountry })

    const transformedOffers = useMemo(() => {
        const offers = offersData?.offers || []

        return offers.map((offer: FlightOffer) => ({
            id: offer.offerId,
            slug: offer.slug,
            title: offer.title,
            description: offer.description,
            imageUrl: offer.imageUrl,
            couponCode: offer.couponCode,
            expiryDate: offer.validTill || '',
            link: `/offers/${offer.slug}`,
            isActive: offer.isActive,
            priority: offer.priority || 999
        })) as Offer[]
    }, [offersData?.offers])

    const sortedOffers = useMemo(() => {
        return [...transformedOffers].sort((a, b) => {
            if (a.isActive !== b.isActive) {
                return a.isActive ? -1 : 1
            }
            if (a.priority !== undefined && b.priority !== undefined) {
                return a.priority - b.priority
            }
            return 0
        })
    }, [transformedOffers])

    if (isError) {
        console.error('Error fetching offers:', error)
    }

    return <OffersGrid offers={sortedOffers} isLoading={isLoading} />
}

export default OffersGridWrapper
